export default "__VITE_ASSET__LIGJML7F__"